"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Team() {
  const {
    ref: headRef,
    isVisible: headVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const artisans = [{
    name: "Marek Kowalski",
    role: "KIEROWNIK BUDOWY",
    origin: "Śląsk / 20 lat doświadczenia w branży",
    quote: "Fundament to serce każdego domu.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723616/img/kierownik_budowy.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723616/img/kierownik_budowy.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723616/img/kierownik_budowy.webp-wvc-sizes"
  }, {
    name: "Anna Nowak",
    role: "SPECJALISTA DS. WYCEN",
    origin: "Śląsk / 12 lat w logistyce budowlanej",
    quote: "Precyzyjna wycena to spokój inwestora.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723616/img/specjalista_wycen.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723616/img/specjalista_wycen.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723616/img/specjalista_wycen.png-wvc-sizes"
  }, {
    name: "Piotr Zieliński",
    role: "MISTRZ BRUKARSTWA",
    origin: "Śląsk / 15 lat układania nawierzchni",
    quote: "Kostka brukowa to wizytówka posesji.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723616/img/mistrz_brukarstwa.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723616/img/mistrz_brukarstwa.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723616/img/mistrz_brukarstwa.png-wvc-sizes"
  }, {
    name: "Tomasz Wiśniewski",
    role: "OPERATOR MASZYN",
    origin: "Śląsk / 18 lat pracy w terenie",
    quote: "Ziemia wymaga szacunku i precyzji.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723616/img/operator_maszyn.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723616/img/operator_maszyn.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723616/img/operator_maszyn.png-wvc-sizes"
  }, {
    name: "Katarzyna Wójcik",
    role: "KOORDYNATOR PROJEKTÓW",
    origin: "Śląsk / 10 lat w zarządzaniu budową",
    quote: "Terminowość to nasza główna zasada.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723616/img/koordynator_projektow.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723616/img/koordynator_projektow.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723616/img/koordynator_projektow.webp-wvc-sizes"
  }, {
    name: "Robert Kamiński",
    role: "SPECJALISTA INSTALACJI",
    origin: "Śląsk / 14 lat w instalacjach podziemnych",
    quote: "Niewidoczne instalacje muszą działać bezbłędnie.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723616/img/specjalista_instalacji.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723616/img/specjalista_instalacji.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723616/img/specjalista_instalacji.png-wvc-sizes"
  }];
  return;
}
function ArtisanCard({
  person,
  offsetClass,
  index,
  ...rest
}: {
  person: {
    name: string;
    role: string;
    origin: string;
    quote: string;
    image: string;
    srcset: string;
    sizes: string;
  };
  offsetClass: string;
  index: number;
  [key: string]: any;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <div ref={ref} {...rest} className={`group ${offsetClass} transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`} style={{
    transitionDelay: `${index % 3 * 120}ms`
  }}>
      <div className="relative overflow-hidden bg-card rounded-lg shadow-md">
        <div className="aspect-[3/4] w-full overflow-hidden">
          <img src={person.image} data-wvc-srcset={person.srcset} data-wvc-sizes={person.sizes} alt={person.name} loading="lazy" decoding="async" className="w-full h-full object-cover transition-all duration-[1200ms] ease-out group-hover:scale-[1.02]" />
        </div>
      </div>

      <div className="h-px w-full bg-border mt-6" />

      <div className="pt-6">
        <p className="font-default text-[10px] tracking-[0.3em] text-primary uppercase mb-4">
          {person.role}
        </p>

        <div className="relative inline-block">
          <h3 className="font-default font-bold text-3xl md:text-4xl text-foreground leading-tight">
            {person.name}
          </h3>
          <span className="absolute -bottom-1 left-0 h-px bg-primary w-0 group-hover:w-full transition-all duration-700 ease-out" />
        </div>

        <p className="font-default italic text-sm text-muted-foreground mt-4 leading-relaxed">
          {person.origin}
        </p>

        <div className="mt-6 pl-4 border-l-2 border-primary">
          <p className="font-default text-base md:text-lg text-secondary italic leading-relaxed">
            — {person.quote}
          </p>
        </div>
      </div>
    </div>;
}